(function () {
  var SELECTOR = '[data-campaign-video]';

  function prefersReducedMotion() {
    return !!(window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches);
  }

  function play(video) {
    // Autoplay is only permitted while muted, and Safari wants the property
    // set in script as well as the attribute in the markup.
    video.muted = true;

    var started = video.play();
    if (started && started.catch) {
      // A refused play leaves the poster showing, which is the fallback anyway.
      started.catch(function () {});
    }
  }

  function watch(video) {
    if (!('IntersectionObserver' in window)) {
      play(video);
      return;
    }

    // A full bleed campaign video is wasted work while it is off screen.
    var observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          play(entry.target);
        } else {
          entry.target.pause();
        }
      });
    }, { threshold: 0.1 });

    observer.observe(video);
  }

  function init(root) {
    // Reduced motion keeps the poster: the video is simply never started.
    if (prefersReducedMotion()) return;

    var scope = root && root.querySelectorAll ? root : document;
    Array.prototype.forEach.call(scope.querySelectorAll(SELECTOR), watch);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      init(document);
    });
  } else {
    init(document);
  }

  document.addEventListener('shopify:section:load', function (event) {
    init(event.target);
  });
})();
